module.exports = __webpack_public_path__ + "media/hallBgm.79a02809.mp3";